/* TODO: Stubbed out button, PinButton component button to be implemented */

import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

import { BaseActionButtonProps } from '../BaseActionButtonProps';

import commonStyles from '../ActionButtonCommon.module.scss';
import styles from './PinButton.module.scss';
import CtaLink from 'components/helpers/Atoms/Cta/CtaLink';
import useDictionary from 'lib/hooks/useDictionary';
import { useContentItem } from 'lib/hooks/useContentItem';

interface PinButtonProps extends BaseActionButtonProps {
  isSubAction?: boolean;
}

export function PinButton({
  label,
  variant,
  isSubAction = false,
  toolbarIdentifier,
  eventPositionSuffix,
}: PinButtonProps): JSX.Element {
  const contentItem = useContentItem();

  const [pageUrl, setPageUrl] = useState(contentItem?.PageUrl || '');
  const [metaDescription, setMetaDescription] = useState(contentItem?.Description || '');

  const { getDictionaryValue } = useDictionary();

  // Update with meta tag values on client side after hydration
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const ogUrl = document.querySelector('meta[property="og:url"]')?.getAttribute('content');
      if (ogUrl) {
        setPageUrl(ogUrl);
      } else if (!contentItem?.PageUrl && typeof window !== 'undefined') {
        setPageUrl(window.location.href);
      }

      const descMeta = document.querySelector('meta[name="description"]')?.getAttribute('content');
      if (descMeta) {
        setMetaDescription(descMeta);
      }
    }
  }, [contentItem?.PageUrl]);

  const pageImageUrl = contentItem?.StandardImageUrl || '';

  // Create Pinterest pin link
  const pinUrl = `https://pinterest.com/pin/create/button?url=${encodeURIComponent(pageUrl)}&media=${encodeURIComponent(pageImageUrl)}&description=${encodeURIComponent(metaDescription)}`;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    // Open Pinterest in popup window
    if (typeof window !== 'undefined') {
      const popupFeatures =
        'width=900,height=900,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes';
      window.open(pinUrl, '_blank', popupFeatures);
    }
  };

  const getGtmPosition = (): string => {
    return [toolbarIdentifier, eventPositionSuffix].filter(Boolean).join('.') || '';
  };

  const gtmEvent = {
    social_network: 'Pinterest',
    event: 'social_share',
    position: getGtmPosition(),
  };

  return (
    <div
      className={clsx({
        [commonStyles['actionButtonWrapper--horizontal']]: variant === 'horizontal',
      })}
    >
      <CtaLink
        ctaStyle={variant === 'horizontal' && !isSubAction ? 'link-invert-underline' : 'none'}
        ctaVariant="brand"
        url={pinUrl}
        suppressNewTabIcon
        className={clsx(
          commonStyles.actionButtonBase,
          commonStyles[`actionButton--${variant}`],
          isSubAction && commonStyles['actionButtonSubAction']
        )}
        onClick={handleClick}
        aria-label={`${label}, ${getDictionaryValue('Common.OpensInNewWindow', '(Opens in a new window)')}`}
        ctaIconBefore="pinterest"
        ctaIconNoSpacer={variant === 'vertical'}
        ctaIconSize="sm"
        ctaIconClassName={styles.icon}
        gtmEvent={gtmEvent}
      >
        {label}
      </CtaLink>
    </div>
  );
}
